import { render, staticRenderFns } from "./PlayVideoModal.vue?vue&type=template&id=6fc015c4&scoped=true"
import script from "./PlayVideoModal.vue?vue&type=script&lang=js"
export * from "./PlayVideoModal.vue?vue&type=script&lang=js"
import style0 from "./PlayVideoModal.vue?vue&type=style&index=0&id=6fc015c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc015c4",
  null
  
)

export default component.exports